import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './index.styl';

function exit() {
  if (!process.env.BROWSER_RUNTIME) return;

  window.ramblerIdHelper.logout();
}

const Logout = ({ className, children }) => (
  <span
    onClick={exit}
    className={cx(styles.logout, className)}
  >
    {children}
  </span>
);

Logout.propTypes = {
  /** Имя класса для стилизации */
  className: PropTypes.string,

  /** Содержимое, которое будет отрендерено компонентом */
  children: PropTypes.node,
};

Logout.defaultProps = {
  children: 'Выйти',
};

export default Logout;
